










import { defineComponent } from '@vue/composition-api';

import { toCommaFormat } from '@/utils';

const LineChart = defineComponent({
  props: {
    data: {},
    xAxisLabel: { default: 'เดือน' },
    yAxisLabel: { default: 'จำนวนวัน' },
    height: {},
    options: { default: () => ({}) },
    formatYAxis: {
      type: [Function, Boolean],
      default: true,
    },
  },
  setup(props) {
    const opt = {
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: props.xAxisLabel,
          },
        },
        y: {
          title: {
            display: true,
            text: props.yAxisLabel,
          },
          ticks: {
            // eslint-disable-next-line
            callback: (value: number) => typeof props.formatYAxis === 'function'
              ? props.formatYAxis(value)
              : props.formatYAxis
                ? `${toCommaFormat(value)}` : value,
          },
        },
      },
      ...props.options,
    };

    return {
      opt,
    };
  },
});

export default LineChart;
